<template>
  <div class="slider" v-bind:class="{ inactive: isDisabled }">
    <buttonc
      class="step left"
      v-bind:class="{ disabled: decreaseButtonDisabled }"
      type="small round"
      icon="fa-minus"
      @click="(value -= step), SliderEnd()"
      :styleIcon="{ 'font-size': '8px' }"
    />
    <buttonc
      class="step right"
      v-bind:class="{ disabled: increaseButtonDisabled }"
      type="small round"
      icon="fa-plus"
      @click="(value += step), SliderEnd()"
      :styleIcon="{ 'font-size': '8px', top: '-2px' }"
    />
    <div class="bar">
      <div
        class="handle-container"
        v-bind:style="{ left: GetOffset() }"
        v-on:mousedown="SliderStart($event)"
      >
        <div class="handle">
          <div class="amount">
            {{ labelValue }}
          </div>
        </div>
      </div>
    </div>
    <div class="amount min">
      {{ labelMin }}
    </div>
    <div class="amount max">
      {{ labelMax }}
    </div>
    <div class="bar left" v-bind:style="{ width: GetOffset() }"></div>
  </div>
</template>

<script>
import datepickerarray from "./datepickerarray.vue";
import datepicker from "./datepicker.vue";
import dropdownsearch from "./dropdownsearch.vue";
export default {
  name: "datafill",
  components: {
    datepickerarray,
    datepicker,
    dropdownsearch,
  },

  created() {
    var message = this;
    if (this.state) for (var x in this.state) this[x] = this.state[x];
  },
  destroyed() {},
  computed: {
    isDisabled() {
      return this.disabled || (this.DisabledCheck && this.DisabledCheck());
    },
    labelMin() {
      if (this.DisplayLabel) return this.DisplayLabel(this.min);
      return this.min;
    },
    labelMax() {
      if (this.DisplayLabel) return this.DisplayLabel(this.max);
      return this.max;
    },
    labelValue() {
      if (this.DisplayLabel) return this.DisplayLabel(this.value);
      return this.value;
    },
    decreaseButtonDisabled() {
      return this.value <= this.min;
    },
    increaseButtonDisabled() {
      return this.value >= this.max;
    },
  },
  data() {
    return {
      startPos: { x: 0, y: 0 },
      sliding: false,
      box: null,
      min: 0,
      max: 100,
      value: 50,
      DisabledCheck: null,
      disabled: false,
      step: 1,
    };
  },
  watch: {
    state: {
      immediate: true,
      handler(newVal, oldVal) {
        let view = this;
        for (var x in newVal) this[x] = newVal[x];
        if (
          isNaN(parseInt(this.value)) &&
          !isNaN(parseInt(this.min)) &&
          isNaN(parseInt(this.max))
        )
          this.value = (this.min + this.max) * 0.5;
        if (
          isNaN(parseInt(this.min)) ||
          isNaN(parseInt(this.max)) ||
          this.min === this.max
        )
          this.disabled = true;
      },
    },
  },
  props: {
    state: Object,
  },
  methods: {
    SliderStart($event) {
      if (this.IsDisabled) return;
      this.box = $event.currentTarget.parentNode.getBoundingClientRect();
      this.sliding = true;
      this.startPos = window.mouse;
      window.mouse.click = true;
      this.SliderWatch();
    },
    SliderWatch() {
      let view = this;
      let factor = (window.mouse.x - this.box.left) / this.box.width;

      this.value = (this.max - this.min) * factor + this.min;

      this.value = this.value - (this.value % this.step);

      if (this.value < this.min) this.value = this.min;
      if (this.value > this.max) this.value = this.max;

      if (window.mouse.click) {
        requestAnimationFrame(function () {
          view.SliderWatch();
        });
      } else {
        this.SliderEnd();
      }
    },
    SliderEnd() {
      this.sliding = false;
      this.box = null;
      if (this.value < this.min) this.value = this.min;
      if (this.value > this.max) this.value = this.max;
      if (this.callback) this.callback(this.value, this.object);
      this.$emit("callback", this.value, this.object);
    },
    GetOffset() {
      if (isNaN(parseInt(this.min)) || isNaN(parseInt(this.max))) return "50%";
      if (this.min === this.max) return "50%";
      return 100 * ((this.value - this.min) / (this.max - this.min)) + "%";
    },
    GetOffsetLeftWidth() {
      if (isNaN(parseInt(this.min)) || isNaN(parseInt(this.max)))
        return "calc(50% - 10px)";
      if (this.min === this.max) return "calc(50% - 10px)";
      return (
        "calc(" +
        100 * ((this.value - this.min) / (this.max - this.min)) +
        "%" +
        " - 10px)"
      );
    },
  },
};
</script>

<style scoped>
.slider {
  border-radius: 100px;
  position: relative;
  width: 100%;
  height: 20px;
  width: calc(100% - 46px) !important;
  left: 30px;
}

.slider .bar {
  position: absolute;
  /*left: 10px;
        width: calc(100% - 20px);*/
  left: 0;
  width: 100%;
  height: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  background: var(--contrast-2);
}

.slider .bar.left {
  background: var(--mp);
}

.slider .bar .handle-container {
  position: absolute;
  height: 35px;
  width: 22px;
  bottom: -5px;
  margin: auto;
  border-radius: 100px;
  cursor: pointer;
  margin-left: -10px;
  z-index: 2;
}

.slider .bar .handle-container .handle {
  position: absolute;
  height: 20px;
  width: 2px;
  background: #404040;
  bottom: 2px;
  margin: auto;
  left: 0;
  right: 0;
  pointer-events: none;
}

.slider.inactive .handle-container {
  /*background: #ccc;
        cursor: default;*/
}

.slider .amount {
  position: absolute;
  margin: auto;
  display: inline-block;
  pointer-events: none;
  width: fit-content;
  padding: 5px;
  border-radius: 5px;
  transform: translate(-50%, -90%);
  height: 25px;
  line-height: 13px;
  margin-left: 0px;
  color: var(--mp);
  font-family: DistrictProBold;
  opacity: 0;
  opacity: 1;
  font-size: 13px;
}

.slider .amount.min {
  color: var(--contrast-2);
  left: 0;
  font-family: DistrictProBook;
}

.slider .amount.max {
  color: var(--contrast-2);
  right: 0;
  margin-left: initial;
  margin-right: 0;
  font-family: DistrictProBook;
  transform: translate(50%, -90%);
}

.slider:hover .amount {
  opacity: 1;
}

.step {
  position: absolute;
  top: 0;
  left: -30px;
  bottom: 0;
  margin: 2px 5px;
  height: 20px;
  width: 20px;
}

.step.right {
  left: initial;
  right: -14px;
}
</style>
